module.exports = __webpack_public_path__ + "static/media/ordernow-cookie-box.f33bc883.png";